import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../../Components/assets/Images/congratsdoneimage.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  esignAPICall,
  esignDocumentAPICall,
  stageDetailsAPICall,
} from "../../shared/APICalls";
import { useDispatch, useSelector } from "react-redux";
import ErrorImage from "../../Images/errorImage.png";
import routesData from "../../shared/routes.json";
import styles from "../Redirect.module.scss";
import { REDIRECTURL } from "../../shared/constants";

export default function SuccessEsignPage() {
  const [countDown, setCountDown] = useState(3);
  const [displayError, setDisplayError] = useState(false);
  const [loading, setloading] = useState(false);
  const [agentPlatform, setAgentPlatform] = useState("");
  const pathName = useLocation().search;
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const code = params.id;
  const state = params.state;
  const status = params.status;
  // console.log(urlParams,"urlParams",window.location.href );
  sessionStorage.setItem("access-token", state);

  const navigationData = routesData;
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      // console.log("cancel");
      setDisplayError(true);
    } else {
      setDisplayError(false);
      senEsignDetails();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  function senEsignDetails() {
    // let obj: any = {
    //   id: code,
    // };
    setloading(true);
    esignDocumentAPICall()
      .then((response: any) => {
        let agent: any;
        const userAgent = navigator.userAgent.toLowerCase();

        if (/iphone|ipad|ipod/.test(userAgent)) {
          agent = "iOS";
          setAgentPlatform("iOS");
        } else if (/android/.test(userAgent)) {
          agent = "Android";
          setAgentPlatform("Android");
        } else {
          agent = "Other";
          setAgentPlatform("Other");
        }
        setCountDown(3);
        setloading(false);
        // if (agent === "iOS") {
        //   navigate("/congratulations");
        // } else {
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}congratulations`;
          // window.close();
        }, 3000);
        // }
      })
      .catch((error: any) => {
        setloading(false);
        // if (agentPlatform === "iOS") {
        //   StageDetails();
        // } else {
        window.location.href = `${REDIRECTURL}esign`;
        // }

        setDisplayError(true);
      });
  }

  function StageDetails() {
    let obj: any = {
      stage: "esign",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        navigate("/esign");
      })
      .catch((error: any) => {});
  }

  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={DoneImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in ${countDown} seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
